import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tooltip'];

  connect() {
    this.viewportWidth = window.innerWidth;
    this.hasBeenReplaced = false;
  }

  replaceTooltip() {
    const tooltipRect = this.tooltipTarget.getBoundingClientRect();

    if (tooltipRect.right > this.viewportWidth) {
      this.tooltipTarget.style.left = `${this.viewportWidth - tooltipRect.right}px`;
      this.hasBeenReplaced = true;
    }
  }
}
